// The `case` query param that WorkQueue.tsx reads (see `searchParams.get('case')`
// in pages/WorkQueue.tsx) to auto-select and scroll to a specific case.
const WORK_QUEUE_CASE_PARAM = 'case';

/**
 * Builds a deep link into the Work Queue pinned to a specific patient's case.
 *
 * Pass `absolute: true` when the href flows through validation that requires
 * a fully-qualified URL (e.g. `safeHref`'s `new URL()` check in PatientInfoPanel);
 * plain relative paths work fine for in-app anchors like ConversationPanel's.
 */
export function buildWorkQueueCaseUrl(patientId: string, options?: { absolute?: boolean }): string {
    const path = `/work-queue?${WORK_QUEUE_CASE_PARAM}=${encodeURIComponent(patientId)}`;
    return options?.absolute ? `${window.location.origin}${path}` : path;
}
